<template>
    <div class="w1200 audition-page" v-loading="loading">
        <div class="audition-type" style="margin-bottom:16px;">
            <div class="desc">方案详情</div>
            <div class="actions">
                <span class="apply_sss" @click="goBack">返回栏目</span>
            </div>
        </div>

        <template v-if="detail">
            <entry-detail-panel
                :entry="detail"
                :lottery-options="lotteryOptions"
                :downloading="downloading"
                @download="handleDownload" />

            <div class="audition-action-box">
                <div class="box-title">跟单意向</div>
                <div class="follow-row">
                    <template v-if="detail.periodOperable">
                        <el-button
                            v-if="loggedIn && !detail.followIntented"
                            plain
                            class="audition-follow-cancel-btn"
                            @click="handleFollow">表达跟单意向</el-button>
                        <el-button
                            v-else-if="detail.followIntented"
                            plain
                            class="audition-follow-cancel-btn"
                            :loading="followCanceling"
                            @click="handleCancelFollow">取消跟单意向</el-button>
                    </template>
                    <el-tag v-else type="info">本期已截止</el-tag>

                    <span class="follow-count">
                        跟单意向：{{ detail.followIntentCount || 0 }} / {{ followThreshold }} 人
                    </span>
                    <el-tag v-if="detail.canInitCrowdfunding" type="warning">已达跟单阈值</el-tag>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { getEntryDetail, followIntent, cancelFollowIntent, getCurrentPeriod, downloadEntry } from '@/api/audition'
import { queryLotteryType } from '@/api/common'
import EntryDetailPanel from './components/EntryDetailPanel.vue'
import { filterAuditionLotteryOptions, hxwyszHomeLocation } from './utils'

export default {
    components: { EntryDetailPanel },
    data () {
        return {
            loading: false,
            downloading: false,
            detail: null,
            lotteryOptions: [],
            followThreshold: 50,
            followCanceling: false
        }
    },
    computed: {
        loggedIn () {
            return !!this.vuex_token
        }
    },
    mounted () {
        this.loadLotteryTypes()
        this.loadDetail()
    },
    methods: {
        goBack () {
            const preType = (this.detail && this.detail.preType) || this.$route.query.preType
            this.$router.push(hxwyszHomeLocation(preType))
        },
        loadLotteryTypes () {
            queryLotteryType().then(res => {
                if (res.code === 200) {
                    this.lotteryOptions = filterAuditionLotteryOptions(res.data)
                }
            })
        },
        loadPeriodThreshold (preType) {
            if (!preType) return
            getCurrentPeriod(preType).then(res => {
                if (res.code === 200 && res.data) {
                    this.followThreshold = res.data.followIntentThreshold || 50
                }
            })
        },
        loadDetail () {
            this.loading = true
            getEntryDetail(this.$route.params.id).then(res => {
                if (res.code === 200) {
                    this.detail = res.data
                    this.loadPeriodThreshold(this.detail.preType)
                } else {
                    this.$message.error(res.msg || '加载失败')
                }
                this.loading = false
            }).catch(() => { this.loading = false })
        },
        goLogin () {
            this.$router.push('/login?redirect=' + encodeURIComponent(this.$route.fullPath))
        },
        handleFollow () {
            if (!this.loggedIn) {
                this.goLogin()
                return
            }
            followIntent(this.detail.id).then(res => {
                if (res.code === 200) {
                    this.$message.success((res.header && res.header.msg) || res.msg || '已表达跟单意向')
                    this.loadDetail()
                } else {
                    this.$message.error(res.msg || '操作失败')
                }
            })
        },
        handleCancelFollow () {
            if (!this.loggedIn) {
                this.goLogin()
                return
            }
            this.$confirm('确定取消跟单意向吗？', '提示', { type: 'warning' }).then(() => {
                this.followCanceling = true
                cancelFollowIntent(this.detail.id).then(res => {
                    if (res.code === 200) {
                        this.$message.success((res.header && res.header.msg) || res.msg || '已取消跟单意向')
                        this.loadDetail()
                    } else {
                        this.$message.error(res.msg || '操作失败')
                    }
                    this.followCanceling = false
                }).catch(() => { this.followCanceling = false })
            }).catch(() => {})
        },
        handleDownload () {
            if (!this.detail || !this.detail.id) return
            this.downloading = true
            downloadEntry(this.detail.id).then(res => {
                if (!res || !(res instanceof Blob)) {
                    this.$message.error('下载失败，请稍后重试')
                    this.downloading = false
                    return
                }
                res.arrayBuffer().then(buffer => {
                    const bytes = new Uint8Array(buffer)
                    if (bytes.length >= 2 && bytes[0] === 0x50 && bytes[1] === 0x4B) {
                        this.$message.error('服务未更新，下载内容异常，请联系管理员')
                        this.downloading = false
                        return
                    }
                    let fileName = this.detail.attachmentFileName
                    if (!fileName) {
                        const base = (this.detail.title || '海选方案').replace(/[\\/:*?"<>|]/g, '_')
                        fileName = base + '.txt'
                    }
                    this.$utils.downloadFile(bytes, fileName, 'text/plain;charset=utf-8')
                    this.downloading = false
                }).catch(() => {
                    this.$message.error('下载失败，请稍后重试')
                    this.downloading = false
                })
            }).catch(() => {
                this.$message.error('下载失败，请稍后重试')
                this.downloading = false
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./audition.scss";
</style>
